import { render, staticRenderFns } from "./TileIcon.vue?vue&type=template&id=8affe170&scoped=true&"
import script from "./TileIcon.vue?vue&type=script&lang=js&"
export * from "./TileIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8affe170",
  null
  
)

export default component.exports